export enum PLATFORM { // SSP와 TW은 반대입니다. // SSP (IOS: 1, Android: 2)
    ANDROID = 1,
    IOS = 2,
}; // IOS, ANDROID ~~~
